import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['Camila', 'Tomás', 'Lucía', 'Martina', 'Juan Cruz', 'Sofía', 'Nicolás', 'Valentina', 'Agustín', 'Florencia', 'Matías', 'Brenda', 'Federico', 'Julieta', 'Santiago', 'Micaela', 'Joaquín', 'Carolina', 'Franco', 'Antonella'];
const cities = ['Buenos Aires', 'CABA', 'La Plata', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Mar del Plata', 'Salta', 'Neuquén', 'Bahía Blanca', 'San Juan', 'Santa Fe', 'Corrientes', 'Resistencia', 'Posadas', 'Río Cuarto', 'Bariloche', 'Comodoro Rivadavia'];
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function minutesAgo(): string {
  const n = Math.floor(Math.random() * 9) + 1;
  return `hace ${n} ${n === 1 ? 'minuto' : 'minutos'}`;
}
export function PurchasePopup() {
  const [data, setData] = useState<{
    name: string;
    city: string;
    ago: string;
  } | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let timeoutId: number | undefined;
    let intervalId: number | undefined;
    const show = () => {
      setData({
        name: pick(names),
        city: pick(cities),
        ago: minutesAgo()
      });
      setVisible(true);
      timeoutId = window.setTimeout(() => setVisible(false), 6000);
    };
    const initial = window.setTimeout(show, 4000);
    intervalId = window.setInterval(show, 15000);
    return () => {
      window.clearTimeout(initial);
      if (timeoutId) window.clearTimeout(timeoutId);
      if (intervalId) window.clearInterval(intervalId);
    };
  }, []);
  if (!data) return null;
  return <div className={`fixed bottom-4 left-4 z-50 max-w-xs sm:max-w-sm transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-[150%] opacity-0 pointer-events-none'}`} data-id="element-184">
      <div className="bg-white border border-green-200 rounded-2xl shadow-2xl p-3 sm:p-4 flex items-start gap-3 popup-anim" data-id="element-185">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-186">
          <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-187" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-188">
          <p className="text-sm font-bold text-slate-900 leading-tight" data-id="element-189">
            {data.name} de {data.city}
          </p>
          <p className="text-xs text-slate-600 leading-snug mt-0.5" data-id="element-190">
            acaba de comprar{' '}
            <span className="font-semibold text-green-700" data-id="element-191">
              Carrera Veterinaria 360
            </span>
          </p>
          <p className="text-[10px] text-slate-400 mt-1" data-id="element-192">
            ✅ Compra verificada · {data.ago}
          </p>
        </div>
        <button onClick={() => setVisible(false)} aria-label="Cerrar" className="flex-shrink-0 text-slate-400 hover:text-slate-600" data-id="element-193">
          <XIcon className="w-4 h-4" data-id="element-194" />
        </button>
      </div>
    </div>;
}